<div [ngClass]="focusMode ? 'chat-bubble chat-bubble-focus' : 'chat-bubble'" 
     [class.sending]="isSendingMessage"
     [class.pending-message]="isPendingMessage"
     [class.pending-error]="isPendingMessage && chat.isError"
     [class.pending-progress]="showPendingProgress"
     [class.temporary-error]="hasTemporaryFailure && !isPendingMessage"
     [class.translating]="isTranslating"
     [style.margin-bottom.px]="isLast ? 0 : 16">

<div class="chat-header">
  <!-- Message type icon (SMS/Email) -->
  <div class="chat-icon">
    <mat-icon class="message-type-icon">{{chat.isSms ? 'smartphone' : 'email'}}</mat-icon>
  </div>

  <!-- Sender indicator circle -->
<!-- WITH THIS: -->
@if(!isPendingMessage){
  <div class="sender-indicator" 
       [ngClass]="chat.direction == 'sent' ? 'rep-indicator' : 'lead-indicator'"
       [matTooltip]="getSenderFullName()">
    {{ getSenderInitials() }}
  </div>
}
  

  <!-- ✅ NEW: Different badges for pending vs regular messages -->
  <div *ngIf="isPendingMessage" class="pending-status-badge" [ngClass]="chat.isError ? 'error' : 'processing'">
    <mat-icon>{{chat.isError ? 'error' : (showPendingProgress ? 'schedule' : 'check_circle')}}</mat-icon>
    <span>{{chat.isError ? 'Failed' : (showPendingProgress ? 'Sending' : 'Queued')}}</span>
  </div>

  <!-- ✅ EXISTING: Original temporary error badge for non-pending messages -->
  <div *ngIf="hasTemporaryFailure && !isPendingMessage" class="temporary-error-badge">
    <mat-icon>schedule</mat-icon>
    <span>Queued</span>
  </div>

  <!-- Spacer to push actions to the right -->
  <div class="header-spacer"></div>

  <div class="chat-actions">
    <!-- ✅ NEW: Different actions for pending vs regular messages -->
    
    <!-- Actions for pending messages -->
    <ng-container *ngIf="isPendingMessage">
      <!-- Retry button for failed pending messages -->
 
      <!-- Pending attachments indicator (no dropdown, just display) -->
      <div *ngIf="pendingAttachmentCount > 0" class="pending-attachments-indicator">
        <mat-icon>attach_file</mat-icon>
        <span class="attachment-count">{{pendingAttachmentCount}}</span>
      </div>
    </ng-container>

    <!-- ✅ EXISTING: Actions for regular messages (UNCHANGED) -->
    <ng-container *ngIf="!isPendingMessage">

      <div *ngIf="chat.isAutomation" class="automation-badge">
        <mat-icon>smart_toy</mat-icon>
        <span>Automation</span>
      </div>

      <!-- ← ADD THIS -->
      <div *ngIf="chat.merged_from_lead_id" class="merged-badge">
        <mat-icon>merge_type</mat-icon>
        <span>Merged</span>
      </div>


      <!-- Translate button -->
      <button 
        *ngIf="canTranslate"
        class="action-button translate-button" 
        [class.translated]="currentLanguage !== 'original'"
        (click)="handleTranslate()"
        [matTooltip]="currentLanguage !== 'original' ? 'Show original' : 'Translate message'"
        [disabled]="isTranslating || !rawContent">
        <mat-icon>{{currentLanguage !== 'original' ? 'translate' : 'translate'}}</mat-icon>
      </button>

      <!-- Expand/Collapse button -->
      <button 
        *ngIf="(rawContent?.length > 300 || isTruncated || chat?.attachments?.length > 0 || isHtmlEmail)"
        class="action-button" 
        (click)="toggleContent($event)"
        matTooltip="{{isExpanded ? 'Collapse' : 'Expand'}}">
        <mat-icon>{{ isExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
      </button>

      <!-- Attachments dropdown (unchanged) -->
      <div 
        *ngIf="chat.attachments?.length > 0" 
        [matMenuTriggerFor]="fileAttached" 
        class="attachment-indicator">
        <mat-icon>attach_file</mat-icon>
        <mat-icon>arrow_drop_down</mat-icon>
        <span class="attachment-count">{{chat.attachments.length}}</span>
      </div>

      <!-- More options menu (unchanged) -->
      <div *ngIf="!focusMode && !removeButton" class="more-options">
        <button mat-icon-button [matMenuTriggerFor]="belowMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu class="options-menu" #belowMenu="matMenu" yPosition="below">
          <button 
            *ngIf="!chat.isError && !chat.isSms && !chat.temporary_failure && allowReply" 
            (click)="replyEmail(chat)" 
            mat-menu-item>
            <mat-icon>reply</mat-icon>
            <span>Reply</span>
          </button>
          <button 
            *ngIf="canTranslate"
            (click)="handleTranslate()" 
            mat-menu-item
            [disabled]="isTranslating || !rawContent">
            <mat-icon>translate</mat-icon>
            <span>{{currentLanguage !== 'original' ? 'Show Original' : 'Translate'}}</span>
          </button>
          <button 
            (click)="seeInfo(chat)" 
            mat-menu-item>
            <mat-icon>info</mat-icon>
            <span>Info</span>
          </button>
        </mat-menu>
      </div>
    </ng-container>

    <!-- ✅ EXISTING: Menu for attachments (unchanged) -->
    <mat-menu class="attachment-menu" #fileAttached="matMenu" yPosition="below">
      <button 
        *ngFor="let atach of chat.attachments" 
        mat-menu-item 
        class="attachment-menu-item" 
        (click)="fileClick(atach.cloud_key)">
        <mat-icon *ngIf="atach.type=='video'">video_collection</mat-icon>
        <mat-icon *ngIf="atach.type=='image'">photo_library</mat-icon>
        <mat-icon *ngIf="atach.type=='audio'">audio_file</mat-icon>
        <mat-icon *ngIf="atach.type=='pdf'" style="color: red;">picture_as_pdf</mat-icon>
        <mat-icon *ngIf="atach.type=='exel'" style="color:rgb(12, 170, 12)">table_chart</mat-icon>
        <mat-icon *ngIf="atach.type=='document'">insert_drive_file</mat-icon>
        <span>{{atach.name}}</span>
      </button>
    </mat-menu>
  </div>
</div>

<!-- Chat Body -->
<div class="chat-body">
  <!-- ✅ NEW: Pending message content (simplified UI) -->
  <div *ngIf="isPendingMessage" class="pending-message-body">
    <div class="pending-info">
      <div class="pending-content-preview">
        <div [innerHTML]="chat.content"></div>
      </div>
      
      <div *ngIf="pendingAttachmentCount > 0" class="pending-attachments-info">
        <mat-icon>attach_file</mat-icon>
        <span>{{pendingAttachmentCount}} files will be attached</span>
      </div>
      
      <!-- Progress indicator -->
      <div *ngIf="showPendingProgress" class="pending-progress">
        <mat-spinner diameter="16"></mat-spinner>
        <span>{{temporaryFailureMessage}}</span>
      </div>
    </div>
    
    <!-- Error details for failed pending messages -->
    <div *ngIf="chat.isError" class="pending-error-details">
      <mat-icon>error_outline</mat-icon>
      <span>{{chat.error_message || temporaryFailureMessage}}</span>
    </div>
  </div>

  <!-- ✅ EXISTING: Regular message content (UNCHANGED) -->
  <div *ngIf="!isPendingMessage">
    <!-- Error message display -->
    <div *ngIf="chat.isError" class="error-message">
      <span style="width: 95%;">{{chat.error_message}}</span>
      <mat-icon style="width: 5%;text-align: right;">error_outline</mat-icon>
    </div>
    
    <!-- Temporary failure message display -->
    <div *ngIf="hasTemporaryFailure" class="temporary-failure-message">
      <span style="width: 95%;">{{temporaryFailureMessage}}</span>
      <mat-icon style="width: 5%;text-align: right;">hourglass_bottom</mat-icon>
    </div>

    <!-- Message content -->
    <div class="message-content" [ngClass]="{'truncated': !isExpanded, 'two-line-limit': !focusMode}">
      <div #contentElement>
        <div [innerHTML]="(isExpanded || focusMode) ? sanitizedContent : truncatedContent" class="message-html full-width"></div>
      </div>
    </div>

    <div class="reaction-badge" *ngIf="chat.reactionsReceived?.length > 0">
      <span
        *ngFor="let reaction of chat.reactionsReceived"
        class="reaction-emoji"
        [matTooltip]="getReactionTooltip(reaction)"
        matTooltipPosition="above">
        {{ getReactionEmoji(reaction.reaction_type) }}
      </span>
    </div>

    
  </div>
</div>

<!-- ✅ EXISTING: Attachments display when expanded (unchanged, only for regular messages) -->
<app-display-file 
  *ngIf="!isPendingMessage && chat?.attachments?.length > 0 && isExpanded" 
  [isAlreadySent]="true" 
  [attachedFiles]="[]" 
  [fixedFiles]="chat.attachments">
</app-display-file>


<!-- ✅ EXISTING: Footer with timestamp and status (UNCHANGED) -->
<div class="chat-footer" *ngIf="!focusMode">
  <div class="message-status">
    <!-- <span *ngIf="chat.direction == 'sent'" [ngClass]="{'temporary-status': hasTemporaryFailure || isPendingMessage}">
      {{(hasTemporaryFailure || isPendingMessage) ? 'queued' : chat.direction}}{{chat.isSms? '' : ' by '+chat.typeEmail }}
    </span> -->

    <span *ngIf="chat.direction == 'sent' && hasTemporaryFailure && !isPendingMessage" [ngClass]="{'temporary-status': hasTemporaryFailure}">
      {{(hasTemporaryFailure ) ? 'queued' : chat.direction}}{{chat.isSms? '' : ' by '+chat.typeEmail }}
    </span>

    <span *ngIf="chat.direction == 'sent' && hasTemporaryFailure && isPendingMessage" [ngClass]="{'temporary-status': hasTemporaryFailure}">
      Queued 
    </span>

    <span *ngIf="chat.direction == 'received'" [ngClass]="{'temporary-status': hasTemporaryFailure}">
      {{chat.direction}}{{chat.isSms? '' : ' by '+chat.typeEmail}}
    </span>
  </div>
  <div class="timestamp">
    {{ chat.created_at | customDate }}
    <!-- Show different icons based on delivered/seen/temporary status -->
    <ng-container *ngIf="chat.direction == 'sent' && !chat.isError">
      <!-- Pending/temporary failure: show hourglass icon -->
      <mat-icon *ngIf="hasTemporaryFailure || isPendingMessage" class="temporary-icon">schedule</mat-icon>
      <!-- Not delivered: single checkmark -->
      <mat-icon *ngIf="!chat.delivered_at && !chat.seen_at && !hasTemporaryFailure && !isPendingMessage">done</mat-icon>
      <!-- Delivered but not seen: double checkmark (not colored) -->
      <mat-icon *ngIf="chat.delivered_at && !chat.seen_at && !hasTemporaryFailure && !isPendingMessage">done_all</mat-icon>
      <!-- Seen: double checkmark (colored blue) -->
      <mat-icon *ngIf="chat.seen_at && !hasTemporaryFailure && !isPendingMessage" class="seen">done_all</mat-icon>
    </ng-container>
    <mat-icon 
      *ngIf="chat.isError" 
      class="error-icon">
      warning
    </mat-icon>
  </div>
</div>
</div>